import { Box, Chip, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import MyTypography from "@saleor/components/MyTypography";
import { UserDetailMode } from "@saleor/userManagement/constants";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    box: {
      position: "relative",
      backgroungColor: theme.palette.info.main,
      margin: "-16px 24px 24px 24px",
      width: "100%",
      minHeight: 168,
      backgroundColor: "#F4F7FE",
      padding: "16px",
      borderRadius: "8px",
      lineHeight: "40px"
    },
    placeholder: {
      display: "flex",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontWeight: "unset",
      "& .MuiSvgIcon-root": {
        color: theme.palette.info.main,
        marginRight: "0.4rem",
        height: 20
      },
      "& .MuiTypography-subtitle2": {
        fontSize: 12,
        fontWeight: "unset"
      }
    },
    title: {
      fontWeight: "unset",
      color: "#007E92",
      marginBottom: "0.5rem"
    },
    chip: {
      marginRight: 8,
      height: 28,
      fontSize: 12
    }
  }),
  { name: "UserDetailForm" }
);

interface FormCustomerSoldToListProps {
  onDelete?: (id) => void;
  values?: Array<Record<string, string>>;
  mode?: UserDetailMode;
}

const FormCustomerSoldToList: React.FC<FormCustomerSoldToListProps> = ({
  onDelete,
  values,
  mode
}) => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <>
      <Box className={classes.box} data-testid="formCustomerSoldToList">
        <MyTypography variant="body3" className={classes.title}>
          {intl.formatMessage({
            defaultMessage: "Sold To ที่เลือก"
          })}
        </MyTypography>
        {values.map(item =>
          mode === UserDetailMode.VIEW ? (
            <Chip
              data-testid="selected-soldTo-item"
              className={classes.chip}
              key={item.value}
              label={item.title}
            />
          ) : (
            <Chip
              data-testid="selected-soldTo-item"
              className={classes.chip}
              key={item.value}
              label={item.title}
              onDelete={() => onDelete(item.value)}
              deleteIcon={<CloseIcon data-testid="deleteIcon" />}
            />
          )
        )}
        {values.length === 0 && (
          <div className={classes.placeholder}>
            <InfoOutlinedIcon fill="blue" />
            <MyTypography variant="subtitle2">
              {intl.formatMessage({
                defaultMessage:
                  "ไม่มี Sold To ที่เลือกไว้ กรุณากรอกข้อมูลด้านบนเพื่อค้นหา"
              })}
            </MyTypography>
          </div>
        )}
      </Box>
    </>
  );
};

export default FormCustomerSoldToList;
